<template>
  <div class="h-full overflow-auto">
    <el-table
      ref="scrollTable"
      :data="tableData"
      :height="`calc(100% - 337px)`"
      v-loading="tableLoading"
      highlight-current-row
      @mouseenter.native="mouseBtn('moveIn')"
      @mouseleave.native="mouseBtn('remove')"
    >
      <el-table-column prop="type" label="类型" width="60px" align="center"></el-table-column>
      <el-table-column prop="instrument" label="科室" width="77px" align="center"></el-table-column>
      <el-table-column prop="date" label="日期" width="100px" align="center"></el-table-column>
      <el-table-column prop="verifier" label="检定人" width="65px" align="center"></el-table-column>
      <el-table-column label="操作" width="45px" align="center">
        <template slot-scope="scope">
          <span @click="downloadReport(scope.row)" class="text-[#41DAD4] cursor-pointer">报告</span>
        </template>
      </el-table-column>
    </el-table>

    <div class="h-150px">
      <barChart />
    </div>
    <div class="check-list mt-20px flex text-[#fff]">
      <div class="check-item w-1/3 text-center" v-for="(item, index) in checkList" :key="index">
        <div class="flex justify-center">
          <img :src="item.img" alt="" class="w-69px h-67px">
        </div>
        <div class="mb-5px">{{ item.title }}</div>
        <div class="check-content py-12px px-10px" :style="`background-image: url(${item.bgImg});`">
          <div class="text-12px flex justify-between items-center">
            <div class="text-[#fffc]">总计</div>
            <div class="text-14px">{{ item.total }}</div>
          </div>
          <div class="border my-5px"></div>
          <div class="text-12px flex justify-between items-center">
            <div class="text-[#fffc]">{{ item.rateName }}</div>
            <div class="text-14px">{{ item.rate }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CombustionLaboratoryApi } from '@wiz-api/huizhou2-business'
import dayjs from 'dayjs'
import barChart from './barChart'

const combustionLaboratoryApi = new CombustionLaboratoryApi()

export default {
  name: 'TheNewCheckTask',
  components: {
    barChart,
  },
  data() {
    return {
      tableLoading: false,
      tableData: [],
      scrollDirection: 'down', // 滚动方向 up向上 down向下
      scrollTimer: null,
      checkList: [
        {
          title: '退检',
          total: 0,
          rate: '0/0',
          rateName: '退检率',
          img: require('./image/icon-check.png'),
          bgImg: require('./image/back-01.png')
        },
        {
          title: '延期',
          total: 0,
          rate: '0/0',
          rateName: '延期率',
          img: require('./image/icon-delay.png'),
          bgImg: require('./image/back-02.png')
        },
        {
          title: '证书修改',
          total: 0,
          rate: '0/0',
          rateName: '修改率',
          img: require('./image/icon-cert.png'),
          bgImg: require('./image/back-03.png')
        }
      ],
    }
  },
  methods: {
    // 获取最新检定数据列表
    async getVerificationList() {
      this.tableLoading = true
      const [err, res] = await combustionLaboratoryApi.getVerificationData()
      this.tableLoading = false
      if (!err && res) {
        this.tableData = res.map((item) => {
          return {
            ...item,
            date: item._date ? dayjs(item._date).format('YYYY-MM-DD') : '-',
          }
        })
      }
    },
    // 获取统计数据
    async getStatistics() {
      const [err, res] = await combustionLaboratoryApi.getRates()
      if (!err && res) {
        this.checkList.forEach((item, index) => {
          switch (index) {
            case 0:
              item.total = res.rejectionCount || 0
              item.rate = `${item.total}/${res.totalCount || 0}`
              break
            case 1:
              item.total = res.deferralCount || 0
              item.rate = `${item.total}/${res.totalCount || 0}`
              break
            case 2:
              item.total = res.certificateAmendmentCount || 0
              item.rate = `${item.total}/${res.totalCount || 0}`
              break
            default:
              break
          }
        })
      }
    },
    autoScroll() {
      const dom = this.$refs.scrollTable?.$refs?.bodyWrapper
      if (dom) {
        const scrollHeight = dom.scrollHeight
        const clientHeight = dom.clientHeight
        if (scrollHeight - clientHeight <= 0) return
        this.scrollFun()
      }
    },
    scrollFun() {
      this.stopScroll()
      this.scrollTimer = setInterval(() => {
        const dom = this.$refs.scrollTable?.$refs?.bodyWrapper
        if (!dom) {
          clearInterval(this.scrollTimer)
          return
        }
        const scrollHeight = dom.scrollHeight
        const clientHeight = dom.clientHeight
        const scrollTop = dom.scrollTop
        // 向下滚动
        if (this.scrollDirection === 'down') {
          dom.scrollTop = scrollTop + 1
          if (scrollHeight - clientHeight <= scrollTop + 1) {
            clearInterval(this.scrollTimer)
            this.scrollTimer = null
            this.scrollDirection = 'up'
            setTimeout(() => {
              this.scrollFun()
            }, 1000)
          }
          // 向上滚动
        } else if (this.scrollDirection === 'up') {
          dom.scrollTop = scrollTop - 1
          if (scrollTop - 1 <= 0) {
            clearInterval(this.scrollTimer)
            this.scrollTimer = null
            this.scrollDirection = 'down'
            setTimeout(() => {
              this.scrollFun()
            }, 1000)
          }
        }
      }, 150)
    },
    mouseBtn(type) {
      if (type === 'moveIn') {
        this.stopScroll()
      } else if (type === 'remove') {
        this.autoScroll()
      }
    },
    stopScroll() {
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer)
        this.scrollTimer = null
      }
    },
    downloadReport(row) {
      const files = row.files
      if (files?.length > 0) {
        files.forEach((item) => {
          this.downloadFile(item, '报告')
        })
      }
    },
    downloadFile(url, fileName) {
      const a = document.createElement('a')
      a.href = url
      a.download = url.split('/').pop() || fileName
      a.click()
      window.URL.revokeObjectURL(a.href)
    }
  },
  mounted() {
    this.getVerificationList()
    this.getStatistics()
    setTimeout(() => {
      this.autoScroll()
    }, 1000)
  },
  beforeDestroy() {
    this.stopScroll()
  }
}
</script>

<style lang="scss" scoped>
.check-list {
  .check-item {
    margin-right: 8px;
    &:last-child {
      margin-right: 0;
    }
  }
}
.check-content {
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
::v-deep {
  .el-table {
    font-size: 13px;
    .cell {
      padding-left: 5px;
      padding-right: 5px;
      line-height: 14px;
    }
    th.el-table__cell>.cell {
      padding-left: 5px;
      padding-right: 5px;
    }
  }
}
</style>
